import React from "react";
import { useParams } from "react-router-dom";

const AssetsServe: React.FC = () => {
  const { "*": path } = useParams();

  if (!path) {
    return <div>Asset não encontrado</div>;
  }

  const assetUrl = `/assets/${path}`;

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <img
        src={assetUrl}
        alt={path}
        style={{ maxWidth: "100%", height: "auto" }}
      />
    </div>
  );
};

export default AssetsServe;
